/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpRightIcon16Solid = forwardRef('ArrowDUturnUpRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.247.41a1.125 1.125 0 1 0-1.494 1.68l2.288 2.035H7.25a5.875 5.875 0 0 0 0 11.75h4.5a1.125 1.125 0 0 0 0-2.25h-4.5a3.625 3.625 0 0 1 0-7.25h3.791L8.753 8.409a1.125 1.125 0 1 0 1.494 1.682l3.66-3.253c.95-.845.95-2.33 0-3.176L10.247.409Z" })));
});
